import React from 'react';
import Wrapper from './style';
import { COIN_FULL_NAME } from '../../config/constants';

const Coins = ({ type, small, xs, md, color, large, background = '', nohover = false, fullname = '', onClick, contrast='' }) => {
	const coinStyle = {};
	let wrapClass = 'coin-wrap';
	if (xs) {
		wrapClass += ' xs';
	}
	if (md) {
		wrapClass += ' md';
	}
	if (nohover) {
		wrapClass += ' large-no-hover'
	} else if (large) {
		wrapClass += ' large';
	}
	if (color !== '#000') {
		coinStyle.border = `1.5px solid ${color}`;
	}
	if (background !== '#000') {
		coinStyle.background = `${background}`;
	}
	if (type === 'hex') {
		type = 'xht';
	}
	return (
		<Wrapper className={wrapClass} onClick={onClick}>
			<div className={`coin-ico ${type}`} style={coinStyle}>
				{type &&  <span style={{color:background}} className={contrast && 'invert-color'} >{type.toUpperCase()}</span>  }
				{large ? <p style={{color:background}} className={contrast && 'invert-color'} >{fullname || COIN_FULL_NAME[type]}</p> : null}
			</div>
			{small ? null : (
				<div className="coin-name">{fullname}</div>
			)}
		</Wrapper>
	);
};

Coins.defaultProps = {
	type: 'btc',
	onClick: () => {}
};

export default Coins;
